export default __webpack_public_path__ + "static/media/UMN-Framework for Planning-06.b37018c4.jpg";